import { ResponsiveContainer, BarChart, XAxis, YAxis, Bar } from "recharts";

import './WasteTypeSiteBlock.scss';

interface WasteTypeSiteBlockProps {
  graphData: any[];
  tableData: any[];
  typeArray: any[];
};

const WasteTypeSiteBlock = (props: WasteTypeSiteBlockProps) => {
  const displayedGraphData = props.graphData.filter((_, idx) => idx < 5);
  const filteredTableData = props.graphData.filter((_, idx) => idx < 16);
  const siteHeaders = filteredTableData.map(site => site.name);
  const displayedTableData = props.typeArray.map(type => {
    const valueArr = filteredTableData.map(site => site[type.label]);
    return [
      type.color,
      type.label,
      ...valueArr
    ];
  });
  return (
    <div className='split-container-site'>
      <div className='graph'>
        <ResponsiveContainer width='100%' height={480}>
          <BarChart
            layout='vertical'
            margin={{left: 50, right: 40}}
            data={displayedGraphData}
          >
            <XAxis type='number' minTickGap={10} />
            <YAxis type='category' dataKey="name" />
            {props.typeArray.map((type, idx) =>
              <Bar key={'wt-site-block-' + idx} dataKey={type.label} stackId='a' fill={type.color} barSize={60} />
            )}
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className='table'>
        <table>
          <tr>
            <th style={{ width: '1%', backgroundColor: 'transparent', border: 'transparent' }}></th>
            <th style={{ width: '32%' }}>Customer Site</th>
            {siteHeaders.map((header, idx) =>
              <th key={'wt-site-header-' + idx} style={{ width: (67 / (siteHeaders.length + 1)) + '%' }}>{header}</th>
            )}
          </tr>
          {displayedTableData.map((wt, idx) =>
            <tr key={'wt-period-export-' + idx}>
              <td style={{ width: '1%', border: 'transparent' }}>
                <div className='color-circle' style={{ backgroundColor: wt[0] }}></div>
              </td>
              <td style={{ width: '32%' }}>{wt[1]}</td>
              {siteHeaders.map((_, idx) =>
                <td key={'wt-site-content-' + idx} style={{ width: (67 / (siteHeaders.length + 1)) + '%' }}>{wt[idx + 2]}</td>
              )}
            </tr>
          )}
        </table>
      </div>
    </div>
  );
};

export default WasteTypeSiteBlock;